import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import RequireAuth from "./AuthRouter";
import Container from "./Container";
import LoginPage from "../pages/LoginPage";
import NotFoundPage from "../pages/NotFoundPage";
import Dashboard from "../components/Dashboard";
import MyProfilePage from "../pages/MyProfilePage";
import SupportTable from "../components/tables/SupportTable";
import DocsTable from "../components/tables/DocsTable";
import DetailsTable from "../components/tables/DetailsTable";
import UsersTable from "../components/tables/UsersTable";
import AuditsTable from "../components/tables/AuditsTable";
import AdminCustomersTable from "../components/tables/AdminCustomersTable";
import LGPDPage from "../pages/LGPDPage";
import AdminQueriesTable from "../components/tables/AdminQueriesTable";
import AdminCustomerForm from "../components/forms/AdminCustomerForm";
import InvoicesTable from "../components/tables/InvoicesTable";
import QueriesCreditTable from "../components/tables/QueriesCreditTable";
import QueriesCadastralTable from "../components/tables/QueriesCadastralTable";
import AdminReportDetailedQueriesTable from "../components/tables/AdminReportDetailedQueriesTable";
import AdminRepresentativesTable from "../components/tables/AdminRepresentativesTable";
import AdminRepresentativeForm from "../components/forms/AdminRepresentativeForm";
import PDFQueryPage from "../pages/PDFQueryPage";
import AdminHistoryTable from "../components/tables/AdminHistoryTable";
import ReportTable from "../components/tables/ReportTable";
import AdminPaymentsTable from "../components/tables/AdminPaymentsTable";
import AdminUsersTable from "../components/tables/AdminUsersTable";
import AdminTablesTable from "../components/tables/AdminTablesTable";
import ChargesTable from "../components/tables/ChargesTable";
import BlacklistImportForm from "../components/forms/BlacklistImportForm";
import FormPage from "../pages/FormPage";
import SimulationsTable from "../components/tables/SimulationsTable";
import CRMPage from "../components/tables/CRMPage";
import FunnelManager from "../components/tables/FunnelManager";
import TasksTodayPage from "../pages/TasksTodayPage";
import FinancialManagementPage from "../pages/FinancialManagementPage";
import UserRoutineMetricsPage from "../pages/UserRoutineMetricsPage";
import CustomersListPage from "../pages/CustomersListPage";
import AdminLeadsTable from "../components/tables/AdminLeadsTable";
import EducationalAreaPage from "../pages/EducationalAreaPage";
import WhatsAppChatPageModernV2 from "../pages/WhatsAppChatPageModernV2";
import FinancingSimulatorPage from "../pages/FinancingSimulatorPage";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/form/:id" element={<FormPage />} />

        <Route
          path="/"
          element={
            <RequireAuth>
              <Container>
                <Outlet />
              </Container>
            </RequireAuth>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<UsersTable />} />
          <Route path="queries/details" element={<DetailsTable />} />
          <Route path="queries" element={<QueriesCreditTable />} />
          <Route path="crm" element={<CRMPage />} />
          <Route path="whatsapp" element={<WhatsAppChatPageModernV2 />} />
          <Route path="crm/tasks" element={<TasksTodayPage />} />
          <Route path="funnels" element={<FunnelManager />} />
          <Route path="simulations" element={<SimulationsTable />} />
          <Route path="financiamento" element={<FinancingSimulatorPage />} />
          <Route path="financeiro" element={<FinancialManagementPage />} />
          <Route
            path="admin/routine-metrics"
            element={<UserRoutineMetricsPage />}
          />
          <Route
            path="admin/area-educacional"
            element={<EducationalAreaPage />}
          />
          <Route
            path="queries/blacklist/import"
            element={<BlacklistImportForm />}
          />
          <Route
            path="queries/cadastrals"
            element={<QueriesCadastralTable />}
          />
          <Route path="query/generate-pdf" element={<PDFQueryPage />} />
          <Route path="charges" element={<ChargesTable />} />
          <Route path="reports/queries" element={<ReportTable />} />
          <Route path="invoices" element={<InvoicesTable />} />
          <Route path="audits" element={<AuditsTable />} />
          <Route path="admin/queries" element={<AdminQueriesTable />} />
          <Route
            path="admin/queries-history"
            element={<AdminReportDetailedQueriesTable />}
          />
          <Route
            path="admin/representatives"
            element={<AdminRepresentativesTable />}
          />
          <Route path="admin/customers-list" element={<CustomersListPage />} />
          <Route path="admin/customers" element={<AdminCustomersTable />} />
          <Route path="admin/leads" element={<AdminLeadsTable />} />
          <Route path="admin/history" element={<AdminHistoryTable />} />
          <Route path="admin/users" element={<AdminUsersTable />} />
          <Route path="admin/new-customer" element={<AdminCustomerForm />} />
          <Route
            path="admin/new-representative"
            element={<AdminRepresentativeForm />}
          />
          <Route path="admin/payments" element={<AdminPaymentsTable />} />
          <Route path="admin/tables" element={<AdminTablesTable />} />
          <Route path="docs" element={<DocsTable />} />
          <Route path="profile" element={<MyProfilePage />} />
          <Route path="support" element={<SupportTable />} />
          <Route path="lgpd" element={<LGPDPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
